import { HttpErrorResponse } from '@angular/common/http';
import { IntercityStop, ProductCategory, RidangoReduxAction } from '@ridango/core';

import { tassign } from 'tassign';

import { StopsActions } from './stops.actions';

export const STOPS_STATE_KEY = 'stops';

export interface StopsState {
    all: IntercityStop[];
    byId: any;
    filtered: IntercityStop[];
    origins: IntercityStop[];
    originsById: any;
    destinations: IntercityStop[];
    selected: IntercityStop;
    groups: ProductCategory[];
    defaultGroup: ProductCategory;
    selectedGroup: ProductCategory;
    selectedOrigin: IntercityStop;
    selectedDestination: IntercityStop;
    allAreas: boolean;
    selectedStops: any;
    error?: HttpErrorResponse;
    loading?: boolean;
}

export const STOPS_INITIAL_STATE: StopsState = {
    all: [],
    byId: {},
    filtered: [],
    origins: [],
    originsById: {},
    destinations: [],
    selected: null,
    groups: null,
    defaultGroup: null,
    selectedGroup: null,
    selectedOrigin: null,
    selectedDestination: null,
    allAreas: false,
    selectedStops: [],
    error: null,
    loading: false,
};

export function stopsReducer(lastState: StopsState = STOPS_INITIAL_STATE, action: RidangoReduxAction): StopsState {
    switch (action.type) {
        case StopsActions.FETCH_START:
            return lastState;
        case StopsActions.FETCH_SUCCESS:
            return tassign(lastState, { all: action.payload.all, byId: action.payload.byId });
        case StopsActions.FETCH_FAILED:
            return lastState;
        case StopsActions.FETCH_END:
            return lastState;
        case StopsActions.FETCH_INTERCITY_START:
            return lastState;
        case StopsActions.FETCH_INTERCITY_SUCCESS:
            return tassign(lastState, { origins: action.payload.all, originsById: action.payload.byId });
        case StopsActions.FETCH_INTERCITY_FAILED:
            return lastState;
        case StopsActions.FETCH_ZONES_START:
            return lastState;
        case StopsActions.FETCH_ZONES_SUCCESS:
            return tassign(lastState, {
                all: action.payload.all,
                byId: action.payload.byId,
                filtered: action.payload.all,
            });
        case StopsActions.FETCH_ZONES_FAILED:
            return lastState;
        case StopsActions.FETCH_STOPS_WITH_ZONES_START:
            return { ...lastState, loading: true };
        case StopsActions.FETCH_STOPS_WITH_ZONES_SUCCESS:
            return { ...lastState, all: action.payload.all, loading: false };
        case StopsActions.FETCH_STOPS_WITH_ZONES_FAILED:
            return { ...lastState, error: action.payload, loading: false };
        case StopsActions.SET_GROUPS:
            return tassign(lastState, { groups: action.payload });
        case StopsActions.SET_DEFAULT_GROUP:
            return tassign(lastState, {
                defaultGroup: action.payload,
            });
        case StopsActions.SET_SELECTED_GROUP:
            return tassign(lastState, {
                selectedGroup: action.payload,
                filtered: lastState.all.filter((v) => action.payload.extra_information.zones.includes(v.id)),
                selectedOrigin: null,
                selectedDestination: null,
            });
        case StopsActions.SET_SELECTED_ORIGIN:
            return tassign(lastState, { selectedOrigin: action.payload });
        case StopsActions.SET_SELECTED_DESTINATION:
            return tassign(lastState, { selectedDestination: action.payload });
        case StopsActions.SET_ALL_AREAS_SELECTED:
            return tassign(lastState, { allAreas: action.payload });
        case StopsActions.SET_SELECTED_STOPS:
            return tassign(lastState, { selectedStops: action.payload });
        case StopsActions.CLEAR_ALL_SELECTIONS:
            return tassign(lastState, {
                selectedGroup: null,
                selectedOrigin: null,
                selectedDestination: null,
                allAreas: false,
                filtered: lastState.all,
            });
    }

    return lastState;
}

export interface StopsPartialStoreState {
    [STOPS_STATE_KEY]: StopsState;
}
